import produce from "immer";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import { startEditElement } from "../../../actions/elementListAction";
import { startAddTab } from "../../../actions/tabListAction";
import { Element } from "../../../models/elementModel";
import {
  getMainTabsByElementId,
  getTabListbyElementId,
  getTabsByElementId,
} from "../../../selectors/tabListSelector";
import CollapseProperties from "./collapse/collapseProperties";
import TabListProperties from "./tab/tabListProperties";
import {
  bootstrapColours,
  textBootstrapColours,
} from "../../../utils/constants";
import "./elementProprtiesPanal.scss";
import { Accordion, Button, Card } from "react-bootstrap";
import Switch from "react-switch";

export interface CollapseElementPropertiesProps {
  element: Element;
}

const CollapseElementProperties: FC<CollapseElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
  const tabList = useSelector(getMainTabsByElementId(element.id));
  const addNewTabOption = () => {
    dispatch(
      startAddTab({
        elementId: element.id,
        formId: element.formId,
        name: "Collapse",
        properties: {},
        styles: {},
        isDropDownTab: false,
        isMain: true,
        pairedKey: uuid(),
        tabGroupTitle: "",
      })
    );
  };
  return (
    <div key={`${element.id}`} className="container mt-3">
      <div className="form-group row">
        <label
          htmlFor="elementName"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Name
        </label>
        <div className="col-sm-8">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.name = e.target.value;
              });
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="backgroundColor"
          className="col-sm-4 col-form-label font-size-12 align-text-left pr-0"
        >
          Background
        </label>
        <div className="col-sm-8">
          <select
            value={
              element.properties.backgroundColor
                ? element.properties.backgroundColor.charAt(0).toUpperCase() +
                  element.properties.backgroundColor.slice(1)
                : ""
            }
            id="backgroundColor"
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.backgroundColor = e.target.value.toLowerCase();
              });
              dispatch(startEditElement(newElement));
            }}
          >
            {bootstrapColours.map((item, i) => {
              return (
                <option key={i} value={item.name}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="form-group row">
        <label
          htmlFor="font-default-bootstrap"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Elements Font Color
        </label>
        <div className="col-sm-8">
          <select
            value={
              element.properties.bodyFontColor
                ? element.properties.bodyFontColor.charAt(0).toUpperCase() +
                  element.properties.bodyFontColor.slice(1)
                : ""
            }
            id="font-default-bootstrap"
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, (draft) => {
                draft.properties.bodyFontColor = e.target.value.toLowerCase();
                draft.styles.color = "";
              });
              dispatch(startEditElement(newElement));
            }}
          >
            {textBootstrapColours.map((item, i) => {
              return (
                <option key={i} value={item.name}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <Accordion defaultActiveKey="0">
        <Card className="theam-component">
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font align-text-left"
            eventKey={`0`}
          >
            <div className="row">
              <div className="col-sm-10">Collapsible</div>
              <div className="col-sm-2">
                <i
                  className="fa fa-plus"
                  onClick={(e) => {
                    e.stopPropagation();
                    addNewTabOption();
                  }}
                ></i>
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={`0`}>
            <Card.Body className="p-0">
              {tabList.length > 0 && <CollapseProperties card={tabList} />}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default CollapseElementProperties;
